import React from "react";
import { Route } from "react-router";
import Settings from "pages/settings";
import IdentityVerification from "pages/settings/identity-verification";
import TaxNumber from "pages/settings/tax-number";
import AuthRoute from "helpers/authentication/authRoute";

const SettingsRoutes = () => (
    <>
        <Route
            path="/settings"
            element={
                <AuthRoute>
                    <Settings />
                </AuthRoute>
            }
        />
        <Route
            path="/settings/identityVerification"
            element={
                <AuthRoute>
                    <IdentityVerification />
                </AuthRoute>
            }
        />
        <Route
            path="/settings/taxNumber"
            element={
                <AuthRoute>
                    <TaxNumber />
                </AuthRoute>
            }
        />
    </>
);

export default SettingsRoutes;
